import React from "react";
import { Button } from "react-bootstrap";
// import SelectDropdown from "../../components/components-react/SelectDropdown";
// import { activeInactiveStatus } from "../../components/common-data/DropdowData";

const SubscriptionEditForm = ({
  createSubsFormErrors,
  createSubsFormData,
  setCreateSubsFormData,
  onClickSubmit,
}) => {
  return (
    <div className="paymentLinkForm">
      <form className="formContainer">
        <div className="formInputsGrid">
          <div className="formInputBox">
            <label htmlFor="enteredStartDate" className="formInputLabel">
              Subscription Start Date *
            </label>

            <input
              type="date"
              className={`formInput ${
                createSubsFormErrors.enteredStartDate ? "formError" : ""
              } ${createSubsFormData.enteredStartDate ? "date-has-value" : ""}`}
              name="enteredStartDate"
              value={createSubsFormData.enteredStartDate}
              onChange={(e) =>
                setCreateSubsFormData({
                  ...createSubsFormData,
                  enteredStartDate: e.target.value,
                })
              }
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="enteredExpireDate" className="formInputLabel">
              Subscription Expire Date *
            </label>

            <input
              type="date"
              className={`formInput ${
                createSubsFormErrors.enteredExpireDate ? "formError" : ""
              } ${
                createSubsFormData.enteredExpireDate ? "date-has-value" : ""
              }`}
              name="enteredExpireDate"
              value={createSubsFormData.enteredExpireDate}
              onChange={(e) =>
                setCreateSubsFormData({
                  ...createSubsFormData,
                  enteredExpireDate: e.target.value,
                })
              }
            />
          </div>

          {/* <div className="formInputBox">
            <label htmlFor="selectedStatus" className="formInputLabel">
              Status *
            </label>

            <div className={`commonWrapper`}>
              <SelectDropdown
                options={activeInactiveStatus}
                selectedOption={createSubsFormData.selectedStatus}
                setSelectedOption={(selectedValue) =>
                  setCreateSubsFormData({
                    ...createSubsFormData,
                    selectedStatus: selectedValue,
                  })
                }
                name="Status"
              />
            </div>
          </div> */}
        </div>

        <div
          className="formButtons"
          style={{ justifyContent: "flex-end", marginTop: "20px" }}
        >
          <Button className="saveBtn" variant="danger" onClick={onClickSubmit}>
            Edit Subscription
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SubscriptionEditForm;
